import { lazy } from 'react';

// Lazy load non-critical home page components to reduce main bundle size
export const LazyFeaturedBusinesses = lazy(() => import('@/components/home/FeaturedBusinesses'));
export const LazyWhyTrustUsSection = lazy(() => import('@/components/home/WhyTrustUsSection'));
export const LazySignUpSection = lazy(() => import('@/components/home/SignUpSection'));
export const LazyHowItWorksSection = lazy(() => import('@/components/HowItWorksSection'));
export const LazySuggestBusinessButton = lazy(() => import('@/components/home/SuggestBusinessButton'));
export const LazyAdSnippetsDisplay = lazy(() => import('@/components/ad-snippets/AdSnippetsDisplay'));

// Fallback component for lazy loading
export const LazyHomeFallback = () => (
  <div className="flex items-center justify-center p-4">
    <div className="animate-pulse h-32 bg-muted rounded-lg w-full"></div>
  </div>
);